import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'colonToH',
  standalone: true,
})
export class ColonToHPipe implements PipeTransform {
  transform(value: string): string {
    if (typeof value !== 'string') {
      return value;
    }
    return value.replace(':', 'h');
  }
}
